import React, { createContext, useState, useMemo } from "react";
export const SidebarContext = createContext(void 0);
export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(null);
  const clearSidebar = () => {
    setSidebar(null);
  };
  const contextValue = useMemo(() => ({ sidebar, clearSidebar, setSidebar }), [sidebar]);
  return /* @__PURE__ */ React.createElement(SidebarContext.Provider, { value: contextValue }, children);
};
